import React from "react"
import Icon from "../Icon/Icon"

interface Props {
	imgUrl?: string
	title?: string
	description?: string | JSX.Element
	showCloseButton?: boolean
	onClose?: () => void
}

export default function FeatureHighlightBanner({imgUrl, title, description, showCloseButton = false, onClose}: Props) {
	return (
		<div className="feature-highlight-banner">
			{imgUrl && (
				<div className="feature-highlight-banner-image">
					<img src={imgUrl} alt="" />
				</div>
			)}
			<div className="feature-highlight-banner-texts">
				{title && <div className="feature-highlight-banner-title">{title}</div>}
				{description && <div className="feature-highlight-banner-description">{description}</div>}
			</div>
			{showCloseButton && (
				<div className={"feature-highlight-close-button"} onClick={onClose}>
					<Icon icon="delete-close-x" size={16} />
				</div>
			)}
		</div>
	)
}
